export const ru = {
  // Navigation
  nav: {
    home: "Главная",
    ourServices: "Наши Услуги",
    aboutUs: "О Нас",
    ourTeam: "Наша Команда",
    contactUs: "Связаться "
  },

  // Hero Section
  hero: {
    title: "Расширяйтесь глобально с уверенностью",
    subtitle: "Мы поддерживаем вас в создании вашего бизнеса в ОАЭ, Саудовской Аравии и России.",
    consultationTitle: "Забронируйте Бесплатную Консультацию Сейчас",
    startNow: "Начать",
    modalTitle: "Забронируйте Бесплатную Консультацию",
    countrySelect: "Выберите Вашу Страну",
    countryPlaceholder: "Выберите страну",
    personalInfo: "Личная Информация",
    firstName: "Имя",
    lastName: "Фамилия",
    emailAddress: "Адрес Электронной Почты",
    nationality: "Национальность",
    phoneNumber: "Номер Телефона",
    servicesLabel: "Услуги, Которые Вы Хотите",
    serviceSelect: "Выберите услугу",
    service1: "Открытие Банковских Счетов",
    service2: "Услуги по Визам и Иммиграции",
    service3: "Бронирование Отелей",
    service4: "Авиабилеты",
    service5: "Разработка Веб-сайтов",
    service6: "Разработка Мобильных Приложений",
    submit: "Отправить"
  },

  // About Us Section
  aboutUs: {
    title: "О Нас",
    paragraph1: "Itqan Business Services была основана в Объединенных Арабских Эмиратах, чтобы помочь предпринимателям и компаниям легко и быстро создавать свои компании. Мы предоставляем полный спектр услуг, включая создание компаний на материке и в свободных зонах, услуги PRO и государственные услуги, налоговые консультации и НДС, финансовую отчетность и заверение документов.",
    paragraph2: "За эти годы мы стали надежным партнером для предпринимателей и малых и средних предприятий, предоставляя безупречные юридические, финансовые и нормативные решения, которые поддерживают рост в ОАЭ и за их пределами. Наша миссия ясна: сделать создание и ведение бизнеса простым, быстрым и надежным — чтобы вы могли сосредоточиться на достижении успеха."
  },

  // Services Section
  services: {
    title: "Наши Услуги",
    subtitle: "Мы предоставляем комплексные бизнес-решения",
    startingFrom: "Начиная с",
    mainlandCompany: {
      name: "Образование Компании на Материке",
      desc: "Создайте свою материковую компанию легко. Мы управляем всеми юридическими шагами, чтобы вы могли сосредоточиться на росте вашего бизнеса.",
      price: "10 000 AED"
    },
    freeZoneCompany: {
      name: "Образование Компании в Свободной Зоне",
      desc: "Запустите свой бизнес в свободной зоне быстро и экономично. Наслаждайтесь гибким владением и упрощенной настройкой.",
      price: "6 000 AED"
    },
    proServices: {
      name: "Услуги PRO и Правительственные",
      desc: "От продления лицензий до золотых виз мы плавно управляем всеми вашими правительственными транзакциями."
    },
    taxConsultancy: {
      name: "Налоговые Консультации и НДС",
      desc: "Оставайтесь в соответствии с экспертными налоговыми и НДС рекомендациями. Мы помогаем вам минимизировать риски и максимизировать эффективность."
    },
    financialStatements: {
      name: "Финансовые Отчеты",
      desc: "Точные финансовые отчеты, которые держат ваш бизнес на правильном пути. Мы обеспечиваем прозрачность и соответствие."
    },
    documentAttestation: {
      name: "Заверение Документов",
      desc: "Быстрые и надежные услуги заверения документов для всех ваших бизнес-потребностей."
    },
    bankAccounts: {
      name: "Открытие Банковских Счетов",
      desc: "Профессиональная помощь в открытии банковских счетов для физических и юридических лиц в ОАЭ и за рубежом."
    },
    visaServices: {
      name: "Услуги по Визам и Иммиграции",
      desc: "Комплексные услуги по визам и иммиграции, включая туристические визы, деловые визы и разрешения на проживание."
    },
    hotelBooking: {
      name: "Бронирование Отелей",
      desc: "Удобные услуги бронирования отелей для деловых поездок и отдыха по конкурентоспособным ценам."
    },
    flightTickets: {
      name: "Авиабилеты",
      desc: "Надежные услуги бронирования авиабилетов с доступом к лучшим предложениям и маршрутам по всему миру."
    },
    websiteDevelopment: {
      name: "Разработка Веб-сайтов",
      desc: "Услуги по разработке индивидуальных веб-сайтов для создания вашего онлайн-присутствия и развития бизнеса.",
      price: "1 500 AED"
    },
    mobileAppDevelopment: {
      name: "Разработка Мобильных Приложений",
      desc: "Профессиональная разработка мобильных приложений для платформ iOS и Android.",
      price: "3 500 AED"
    }
  },

  // Our Team Section
  ourTeam: {
    title: "Наша Команда",
    subtitle: "Познакомьтесь с нашими экспертами-профессионалами",
    members: [
      {
        name: "Инж/Хана",
        role: "Руководитель команды по созданию бизнеса"
      },
      {
        name: "Инж/Али",
        role: "Руководитель команды по созданию бизнеса"
      },
      {
        name: "Инж/Абдалла",
        role: "Руководитель команды по созданию бизнеса"
      },
      {
        name: "Инж/Сара",
        role: "Руководитель команды по созданию бизнеса"
      }
    ]
  },

  // Reviews Section
  reviews: {
    title: "Что Говорят Наши Клиенты",
    subtitle: "Отзывы довольных клиентов",
    testimonials: [
      {
        name: "Иван Петров",
        role: "Генеральный директор, ТехСтарт Инк.",
        text: "Itqan сделал создание моей компании в Дубае таким простым и быстрым. Их команда профессионально справилась со всем, и я смог начать свой бизнес без стресса. Настройка свободной зоны была завершена всего за 3 дня!"
      },
      {
        name: "Алексей Смирнов",
        role: "Менеджер по маркетингу, Глобальные Решения",
        text: "Благодаря их налоговым консультациям, я теперь полностью уверен, что мой бизнес соответствует требованиям и финансово защищен. Их экспертиза сэкономила мне тысячи в потенциальных штрафах."
      },
      {
        name: "Михаил Браун",
        role: "Владелец бизнеса, Розничная Сеть",
        text: "Команда PRO-услуг в Itqan исключительна. Они плавно справились со всеми моими правительственными транзакциями, от продления лицензий до заявлений на визы. Настоятельно рекомендую!"
      },
      {
        name: "Егор Вильсон",
        role: "Фрилансер, Цифровое Агентство",
        text: "Как фрилансер, мне нужна была помощь с заверением документов и открытием банковского счета. Itqan сделал все так легко и доступно. Теперь я могу сосредоточиться на своих клиентах, пока они занимаются бумажной работой."
      },
      {
        name: "Дмитрий Ли",
        role: "Предприниматель, Электронная Коммерция",
        text: "Их услуги по финансовой отчетности превосходны. Отчеты точные, детальные и помогли мне получить финансирование для расширения моего бизнеса. Профессиональное обслуживание на протяжении всего процесса!"
      }
    ]
  },

  // Partners Section
  partners: {
    title: "Наши Партнеры",
    subtitle: "Доверяют ведущие организации"
  },

  // Contact Us Section
  contactUs: {
    title: "Связаться ",
    subtitle: "Свяжитесь с нами",
    getInTouch: "Связаться",
    contactInfo: "Контактная Информация",
    sendMessage: "Отправить Сообщение",
    name: "Имя",
    email: "Электронная Почта",
    subject: "Тема",
    message: "Сообщение",
    fullName: "Полное Имя",
    fullNamePlaceholder: "Введите ваше имя",
    emailAddress: "Адрес Электронной Почты",
    emailPlaceholder: "Введите ваш e-mail",
    phoneNumber: "Номер Телефона",
    phonePlaceholder: "Номер Телефона",
    activity: "Деятельность",
    activityPlaceholder: "Введите вашу деятельность",
    submit: "Отправить"
  },

  // Footer
  footer: {
    allRightsReserved: "Все Права Защищены",
    privacyPolicy: "Политика Конфиденциальности",
    termsOfService: "Условия Обслуживания",
    description: "Коммерческие Услуги Иткан – Делаем создание бизнеса легким и быстрым.",
    location: "Местоположение: Дубай, Объединенные Арабские Эмираты",
    phone: "📞 Телефон: +971 XXX XXX XXX",
    email: "✉️ E-mail: info@itqan.com",
    copyright: "© 2025 Коммерческие Услуги Иткан. Все Права Защищены.",
    companyProfile: "Профиль Компании"
  },

  // Ad Section
  ad: {
    title: "Расширяйтесь глобально с уверенностью",
    startNow: "Начать"
  },

  // Statistics Section
  statistics: {
    title: "Наши Достижения",
    subtitle: "Цифры, которые говорят о нашем успехе",
    clients: "Довольные Клиенты",
    experience: "Лет Опыта",
    partners: "Надежные Партнеры"
  }
}; 